import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import { ICatchwerksEnrollmentRequestDTO, ICatchwerksEnrollmentResponseDTO } from "../models/DTO/ICatchwerksEnrollmentDTO";

const enrollUser = async (
    body: ICatchwerksEnrollmentRequestDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<ICatchwerksEnrollmentResponseDTO> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.CatchwerksEnrollment,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
    });

    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || response.statusText);
    }

    return response.json();
};

const CatchwerksService = {
    enrollUser,
};

export default CatchwerksService;
